import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import type { TabVariant } from '@/components/Tab';

export const Wrapper = styled(Box)<{ variant: TabVariant }>`
  ${({ variant }) =>
    variant === 'segmented' &&
    css`
      display: flex;
      width: 100%;
    `}
`;
